import { render, staticRenderFns } from "./ProductGridItem.vue?vue&type=template&id=0bb2229a&"
import script from "./ProductGridItem.vue?vue&type=script&lang=js&"
export * from "./ProductGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb2229a')) {
      api.createRecord('0bb2229a', component.options)
    } else {
      api.reload('0bb2229a', component.options)
    }
    module.hot.accept("./ProductGridItem.vue?vue&type=template&id=0bb2229a&", function () {
      api.rerender('0bb2229a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DynamicTabs/ProductGridItem.vue"
export default component.exports